/* PRS logo strip: on mobile (<768px) the logo row becomes a one-at-a-time slider
   (autoplay, infinite loop, swipe). On larger screens it is left as the static row.
   No dependencies. Without JS the CSS falls back to a swipeable scroll-snap row. */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 767px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var TRANSITION_MS = 300;

  function Slider(root) {
    this.root = root;
    this.viewport = root.querySelector('.prs-logos__viewport');
    this.track = root.querySelector('.prs-logos__set');
    this.interval = Math.max(1, parseFloat(root.getAttribute('data-interval')) || 2) * 1000;
    this.original = this.track ? Array.prototype.slice.call(this.track.children) : [];
    this.timer = null;
    this.busy = false;
    this.paused = false;
    this.active = false;
    this.startX = null;
    this.handlers = {};
  }

  Slider.prototype.enable = function () {
    if (this.active || !this.track || this.original.length < 2) { return; }
    var self = this;
    this.active = true;
    this.root.classList.add('prs-logos--slider');
    this.viewport.setAttribute('aria-roledescription', 'carousel');

    this.handlers.touchstart = function (e) { self.startX = e.touches[0].clientX; self.pause(); };
    this.handlers.touchend = function (e) {
      if (self.startX !== null) {
        var dx = e.changedTouches[0].clientX - self.startX;
        if (Math.abs(dx) > 40) { dx < 0 ? self.next() : self.prev(); }
      }
      self.startX = null;
      self.resume();
    };
    this.handlers.enter = function () { self.pause(); };
    this.handlers.leave = function () { self.resume(); };
    this.viewport.addEventListener('touchstart', this.handlers.touchstart, { passive: true });
    this.viewport.addEventListener('touchend', this.handlers.touchend, { passive: true });
    this.viewport.addEventListener('mouseenter', this.handlers.enter);
    this.viewport.addEventListener('mouseleave', this.handlers.leave);
    this.viewport.addEventListener('focusin', this.handlers.enter);
    this.viewport.addEventListener('focusout', this.handlers.leave);

    this.start();
  };

  Slider.prototype.disable = function () {
    if (!this.active) { return; }
    this.active = false;
    this.stop();
    this.root.classList.remove('prs-logos--slider');
    this.viewport.removeAttribute('aria-roledescription');
    this.viewport.removeEventListener('touchstart', this.handlers.touchstart);
    this.viewport.removeEventListener('touchend', this.handlers.touchend);
    this.viewport.removeEventListener('mouseenter', this.handlers.enter);
    this.viewport.removeEventListener('mouseleave', this.handlers.leave);
    this.viewport.removeEventListener('focusin', this.handlers.enter);
    this.viewport.removeEventListener('focusout', this.handlers.leave);
    // restore original DOM order and clear inline styles
    for (var i = 0; i < this.original.length; i++) { this.track.appendChild(this.original[i]); }
    this.track.style.transition = '';
    this.track.style.transform = '';
    this.busy = false;
  };

  Slider.prototype.start = function () {
    var self = this;
    this.stop();
    if (REDUCED.matches) { return; }
    this.timer = window.setInterval(function () {
      // Self-heal if a breakpoint change event was missed
      if (!MOBILE.matches) { self.disable(); return; }
      if (!self.paused && !document.hidden) { self.next(); }
    }, this.interval);
  };

  Slider.prototype.stop = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };

  Slider.prototype.pause = function () { this.paused = true; };
  Slider.prototype.resume = function () { this.paused = false; };

  /* Move one slide forward: slide the track left by one slide width, then (once the
     transition ends) move the first slide to the end and snap the track back to 0. */
  Slider.prototype.next = function () {
    if (this.busy || !this.active) { return; }
    var self = this;
    this.busy = true;
    var done = false;
    function finish() {
      if (done) { return; }
      done = true;
      self.track.removeEventListener('transitionend', finish);
      self.track.style.transition = 'none';
      self.track.appendChild(self.track.firstElementChild);
      self.track.style.transform = 'translateX(0)';
      void self.track.offsetWidth; // flush so the snap-back is not animated
      self.busy = false;
    }
    this.track.addEventListener('transitionend', finish);
    this.track.style.transition = 'transform ' + TRANSITION_MS + 'ms ease';
    this.track.style.transform = 'translateX(-100%)';
    window.setTimeout(finish, TRANSITION_MS + 80); // in case transitionend never fires
  };

  /* Move one slide back: put the last slide first (offset by one slide), then slide it in. */
  Slider.prototype.prev = function () {
    if (this.busy || !this.active) { return; }
    var self = this;
    this.busy = true;
    this.track.style.transition = 'none';
    this.track.insertBefore(this.track.lastElementChild, this.track.firstElementChild);
    this.track.style.transform = 'translateX(-100%)';
    void this.track.offsetWidth;
    this.track.style.transition = 'transform ' + TRANSITION_MS + 'ms ease';
    this.track.style.transform = 'translateX(0)';
    window.setTimeout(function () { self.busy = false; }, TRANSITION_MS + 40);
  };

  var instances = [];

  function sync() {
    instances.forEach(function (s) { MOBILE.matches ? s.enable() : s.disable(); });
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-prs-logo-slider]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.__prsLogoSlider) { return; }
      node.__prsLogoSlider = new Slider(node);
      instances.push(node.__prsLogoSlider);
    });
    sync();
  }

  function onChange() { sync(); }
  window.addEventListener('resize', onChange);
  if (MOBILE.addEventListener) { MOBILE.addEventListener('change', onChange); } else { MOBILE.addListener(onChange); }
  if (REDUCED.addEventListener) {
    REDUCED.addEventListener('change', function () {
      instances.forEach(function (s) { if (s.active) { s.start(); } });
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }

  // Theme editor: re-run when a section is added or re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    instances = instances.filter(function (s) { return document.body.contains(s.root); });
    init(e.target);
  });
  document.addEventListener('shopify:section:unload', function () {
    instances = instances.filter(function (s) { return document.body.contains(s.root); });
  });
})();
